import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { ProcedureFilter } from '../../../../model/procedure';
import { AppTypeService } from '../../../../services/appType.service';
import { AppType } from '../../../../model/appType';

@Component({
    selector: 'app-procedure-list-filter',
    templateUrl: './procedure-list-filter.component.html',
    styleUrls: ['./procedure-list-filter.component.scss'],
    standalone: false,
})
export class ProcedureListFilterComponent implements OnInit {

  @Output() filterEmitter = new EventEmitter<ProcedureFilter>();

  form: FormGroup;
  filter: ProcedureFilter;
  expandedFilter = true;
  appTypes: AppType[];
  private destroy$ = new Subject<void>();

  constructor(fb: FormBuilder,
    private appTypeService: AppTypeService
  ) {
    this.cleanFilter();

    this.form = fb.group({
      name: [this.filter.name],
      description: [this.filter.description]
    });
  }

  ngOnInit(): void {
    this.appTypeService.findAll().pipe(takeUntil(this.destroy$)).subscribe((data: AppType[]) => this.appTypes = data);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  doFilter(): void {
    this.expandedFilter = false;

    this.filterEmitter.emit(this.filter);
  }

  cleanFilter(): void {
    this.filter = new ProcedureFilter();
  }

}
